/* eslint-disable no-return-assign */
import PropTypes from 'prop-types';
import React from 'react';
import Overlay from 'react-bootstrap/es/Overlay';
import OverlayTrigger from 'react-bootstrap/es/OverlayTrigger';
import Popover from 'react-bootstrap/es/Popover';
import Tooltip from 'react-bootstrap/es/Tooltip';
import Info from "../../icon-components/info";
var CLASSNAME = 'frc-help';
/**
 * This is the help / tooltip component.
 */

var Help = function Help(_ref) {
  var children = _ref.children,
      id = _ref.id,
      message = _ref.message,
      overlayClassName = _ref.overlayClassName,
      overlayType = _ref.overlayType,
      rootClose = _ref.rootClose,
      tooltipPlacement = _ref.tooltipPlacement,
      trigger = _ref.trigger,
      triggerOverride = _ref.triggerOverride;
  var OverlayClass = overlayType === 'tooltip' ? Tooltip : Popover;
  var content = children || React.createElement("span", null, React.createElement(Info, {
    className: "".concat(CLASSNAME, "-icon")
  }));
  var overlay = React.createElement(OverlayClass, {
    id: id,
    className: overlayClassName
  }, message);

  var _target;

  if (triggerOverride) return React.createElement("span", null, React.createElement(Overlay, {
    show: triggerOverride === 'show',
    placement: tooltipPlacement,
    target: function target() {
      return _target;
    }
  }, overlay), React.createElement("span", {
    ref: function ref(element) {
      return _target = element;
    }
  }, content));
  return React.createElement(OverlayTrigger, {
    overlay: overlay,
    placement: tooltipPlacement,
    rootClose: rootClose,
    trigger: trigger
  }, content);
};

Help.displayName = 'Help';
Help.propTypes = {
  /**
   * You can override the inner icon by defining children
   */
  children: PropTypes.node,

  /**
   * Define html ID attribute
   */
  id: PropTypes.string.isRequired,

  /**
   * The message to be shown
   */
  message: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),

  /**
   * The className used by the Overlay
   */
  overlayClassName: PropTypes.string,

  /**
   * Popover or tooltip type
   */
  overlayType: PropTypes.oneOf(['popover', 'tooltip']),

  /**
   * Specify whether the overlay should trigger onHide when the user clicks outside the overlay
   */
  rootClose: PropTypes.bool,

  /**
   * Sets the direction the Help is positioned towards.
   */
  tooltipPlacement: PropTypes.oneOf(['top', 'left', 'bottom', 'right']),

  /**
   * Trigger lets you override when it is triggered, so "hover" / "focus" / "click"
   */
  trigger: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),

  /**
   * Override the visibility of the trigger: 'show' or 'hide'
   */
  triggerOverride: PropTypes.oneOf(['show', 'hide'])
};
Help.defaultProps = {
  overlayType: 'tooltip',
  rootClose: false,
  tooltipPlacement: 'top',
  trigger: ['hover', 'focus']
};
export default Help;